import { render, staticRenderFns } from "./ThemeForm.vue?vue&type=template&id=e2e47bb6"
import script from "./ThemeForm.vue?vue&type=script&lang=ts"
export * from "./ThemeForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports